<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <div class="holder">
      <div class="row items-center">
        <div class="col-4 q-pl-lg content">
          <h1>Page not found</h1>
          <p><b>The page you're looking for doesn't exist, but you're not at dead end. Here are a few options:</b></p>
          <ul>
            <li>Be sure you have the right url and try again.</li>
            <li>
              Search for a info in <a href="https://wiki.swissre.com/display/CMP/EP+for+Users" target="_blank">wiki</a>
            </li>
            <li>
              Get a help from
              <a
                href="https://swissreesm.service-now.com/now/nav/ui/classic/params/target/incident.do%3Fsys_id%3D-1%26sysparm_query%3Dcategory%3Dincident%5Eassignment_group%3D656e08a91b399d107ccd20a8624bcb45%5Eu_incident_call_code%3DDirect%2520contact%5Epriority%3D4"
                target="_blank"
                >support</a
              >
            </li>
          </ul>
          <q-btn @click="$router.push('/')" no-caps color="primary" text-color="dark" label="Back to Home Page"></q-btn>
        </div>
        <div class="col-8">
          <img :src="$options.notFound" alt="" />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import notFound from '../../assets/404.png';

export default {
  name: 'NotFound',
  notFound,
};
</script>

<style lang="scss" scoped>
.holder {
  border-radius: 15px;
  background-color: white;
  font-size: 18px;

  .content {
    padding-left: 80px;

    @media (max-width: $breakpoint-md-max) {
      padding-left: 40px;
    }
  }

  img {
    width: 100%;
  }

  ul {
    padding-left: 15px;
    margin-bottom: 45px;
  }

  h1 {
    margin: 0;
    font-size: 50px;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 30px;

    @media (max-width: $breakpoint-md-max) {
      font-size: 40px;
    }
  }
}
</style>
